module.exports = __webpack_public_path__ + "static/media/S1-5-Jorb-cod5.eacfd5da.png";